import CornerCutout from 'shared/components/ui/corner-cutout'
import React from 'react'
import useWindowSize from 'shared/hooks/window-size'
import styled from 'styled-components'
import Footer from './footer'
import Header from './header'
import Oops from './oops'

const Container = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: relative;
    width: 100%;
`

const Background = styled.video`
    display: block;
    height: 100%;
    left: 0;
    object-fit: cover;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
`

const VideoEmbed404 = () => {
    const { innerHeight } = useWindowSize()
    return (
        <CornerCutout isVisible>
            <Container>
                <Background src="/static/img/embeds/background-404.mp4" autoPlay loop muted playsInline />
                {innerHeight >= 350 && <Header />}
                <Oops />
                <Footer />
            </Container>
        </CornerCutout>
    )
}

export default VideoEmbed404
